export { default } from './Truncate';
